import React from 'react'
import { Marker, Popup } from 'react-leaflet'
import { Card, CardContent, CardMedia, Typography, Box, Button } from '@mui/material'
import L from 'leaflet'
import { useNavigate } from 'react-router-dom'

const ListingMarker = ({ listing }) => {
  const navigate = useNavigate()

  // Create a minimal custom icon (same as before)
  const propertyIcon = new L.Icon({
    iconUrl:
      'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><circle cx="12" cy="12" r="6" fill="%23007bff"/></svg>',
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
    className: 'minimal-icon',
  })

  const handleViewListing = () => {
    navigate(`/listing/${listing.id}`)
  }

  return (
    <Marker position={[listing.latitude, listing.longitude]} icon={propertyIcon}>
      <Popup className="listing-popup" maxWidth="300">
        <Card sx={{ maxWidth: 280, boxShadow: 'none', cursor: 'pointer' }}>
          <CardMedia
            component="img"
            height="140"
            image={listing.image_url || 'https://via.placeholder.com/300x200?text=No+Image'}
            alt={listing.name || 'Property'}
            sx={{ objectFit: 'cover' }}
          />
          <CardContent sx={{ p: 1.5 }}>
            <Typography variant="subtitle1" component="div" noWrap sx={{ fontWeight: 'bold' }}>
              {listing.name || 'Listing'}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {listing.address || 'No address provided'}
            </Typography>
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}
            >
              <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 'bold' }}>
                €{listing.price ? listing.price.toLocaleString() : 'N/A'}
              </Typography>
              <Button
                variant="contained"
                size="small"
                onClick={(e) => {
                  e.stopPropagation()
                  handleViewListing()
                }}
              >
                View
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Popup>
    </Marker>
  )
}

export default ListingMarker
